import { render } from "./AngebotPage.vue?vue&type=template&id=baf4f3e2&scoped=true"
import script from "./AngebotPage.vue?vue&type=script&lang=js"
export * from "./AngebotPage.vue?vue&type=script&lang=js"

import "./AngebotPage.vue?vue&type=style&index=0&id=baf4f3e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-baf4f3e2"]])

export default __exports__